import { render, staticRenderFns } from "./IconLiked.vue?vue&type=template&id=50000937&"
import script from "./IconLiked.vue?vue&type=script&lang=js&"
export * from "./IconLiked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports